module.exports = __webpack_public_path__ + "static/media/56.4b759f7e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/56.svg
// module id = 182
// module chunks = 0